import React from "react";
import { ReactComponent as Print } from "../../../../assets/icons/print.svg";

export function PatientInitiationTopButtons({
  auxButtons = false,
  isSubmittedPresciberPAF,
  onPrevious,
  onCompleteClick,
  disableCompleteButton,
  onPrint,
  onFinish,
}) {
  return (
    <>
      {!isSubmittedPresciberPAF ? (
        <div
          className="flex items-center justify-end"
          data-testid="patient-initiation-top-buttons"
        >
          {auxButtons && (
            <button
              type="button"
              className="mr-4 rounded-full border border-neutral-400 bg-white px-5 py-2 text-base text-neutral-700 hover:bg-neutral-50"
              onClick={onPrevious}
              data-testid="patient-initiation-cancel-button"
            >
              Cancel
            </button>
          )}
          <button
            type="button"
            className="rounded-full bg-[#009b77] px-6 py-2 font-semibold text-white hover:bg-[#008764] disabled:opacity-60"
            onClick={onCompleteClick}
            disabled={disableCompleteButton}
            data-testid="patient-initiation-complete-button"
          >
            Complete
          </button>
        </div>
      ) : (
        <div
          className="flex items-center justify-end"
          data-testid="patient-initiation-top-buttons"
        >
          {auxButtons && (
            <button
              type="button"
              className="mr-4 inline-flex items-center gap-2 rounded-full border border-neutral-400 bg-white px-5 py-2 text-neutral-700 hover:bg-neutral-50"
              onClick={onPrint}
              data-testid="patient-initiation-print-button"
            >
              Print <Print />
            </button>
          )}
          <button
            type="button"
            className="rounded-full bg-[#009b77] px-6 py-2 font-semibold text-white hover:bg-[#008764]"
            onClick={onFinish}
            data-testid="patient-initiation-finish-button"
          >
            Finish
          </button>
        </div>
      )}
    </>
  );
}
